export default __webpack_public_path__ + "static/media/pantry1-afterA-768w.594d6e11.webp";